import api from 'js/api'
export const getAccountInfoByUserId = id => {
  return api('GET', `v2/accounts/account_info/${id}`).then(res => {
    return res.response
  })
}
